import { useMutation } from "@tanstack/react-query";
import { useApi } from "../../../api/ApiProvider";
import notificationStore from "../../Notification/notificationStore";

export const useRunMaintenanceCheck = () => {
  const { maintenance } = useApi();
  return useMutation({
    mutationFn: async (id: string) => maintenance.runMaintenanceCheck(id),
    onError: (e: any) =>
      notificationStore.showMessage(
        e?.details?.message || e?.message || "Check failed",
        "error",
        e
      ),
  });
};

export const useRunMaintenanceRepair = () => {
  const { maintenance } = useApi();
  return useMutation({
    mutationFn: async (id: string) => maintenance.runMaintenanceRepair(id),
    onSuccess: (result) =>
      notificationStore.showMessage(
        result?.message || "Repair finished",
        "success"
      ),
    onError: (e: any) =>
      notificationStore.showMessage(
        e?.details?.message || e?.message || "Repair failed",
        "error",
        e
      ),
  });
};
